import store from "@/store"
import * as firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"

const config = {
  apiKey: "AIzaSyAiNDZhCfNrycVPKh2okqrJFxGJqg21Yh0",
  authDomain: "designer-3527c.firebaseapp.com",
  databaseURL: "https://designer-3527c.firebaseio.com",
  projectId: "designer-3527c",
  storageBucket: "designer-3527c.appspot.com",
  messagingSenderId: "855087960827",
  appId: "1:855087960827:web:685012061f262b2141565e",
  measurementId: "G-FRB23SZXWZ"
}

firebase.initializeApp(config)

const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()
const postsCollection = db.collection("posts")

function getCurrentUser(): Promise<firebase.User | null> {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        store.dispatch("fetchUserProfile", user)
        store.commit("setLoggedIn")
      } else {
        store.commit("clearUserProfile")
        store.commit("setLoggedOut")
      }
      unsubscribe()
      resolve(user)
    }, reject)
  })
}

export { auth, db, storage, postsCollection, getCurrentUser }
